import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SystemSettings from "../components/SystemSettings";

export default function SystemSettingsPage() {
  return (
    <Stack gap={2} sx={{ py: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        ตั้งค่าระบบ
      </Typography>
      <SystemSettings />
    </Stack>
  );
}
